const NAMESPACE = '@bitsoflove/entity-management';

export const warn = message => console.warn(`${NAMESPACE}: ${message}`);
